exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#ridetable{border:1px solid #000}#rideheader{border:2px solid #000;height:28px}#ridetable .rideheadercell{border:1px solid #000;padding-left:8px;padding-right:8px;color:#000}#ridetable td{padding-left:2px;padding-right:2px;line-height:1.2;height:38px;border:1px solid #000}.speed0{background-color:#e0e0d3}.speed1{background-color:#fff3ca}.speed2{background-color:#fff}.speed3{background-color:#f7d1d3}.pastride{color:#bbb}.pace,.ridelength{white-space:nowrap}.date,.leader,.ridedesc,.where{text-align:left}.nowrap{white-space:nowrap}.gears-intro{font-size:17px}.debug{background:pink}.flex-grow{flex-grow:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5158340e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 11
// module chunks = 0